import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'react-router';
import commonUtil from "../../../../../../utils/commonUtil";
import CreateEvent from "../../../../../createEvent/components/createEvent";
import * as eventDetailsActions from './actions';
import ApplyCSS from "../../../../../../components/ApplyCSS";
const pageName = 'createEvent';

const applicationRoutes = commonUtil.getApplicationRoutes();
const channel = commonUtil.getChannel();
const { saveEventName, handleSaveEventName, handleValidateEventName } = eventDetailsActions;


@connect(store => ({
  store,
  lables: store.labels.data,
  error: store.labels.error,
  loading: store.labels.loading,
  extraData: store.labels.extraData,
}),
  {
    ...eventDetailsActions,
  })


class Personalization extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eventType: '',
      eventDate: '',
      eventId: '',
      ownerName: '',
      coOwnerName: '',
      celebrityName: '',
      showCreateEvent: false,
    };
  }

  componentDidMount(){
    const { userEventDetails } = this.props;
    
    const eventType = userEventDetails?.eventDetailsInfo?.eventType || '';
    const eventDate = userEventDetails?.eventDetailsInfo?.eventDate || '';
    const eventId = userEventDetails?.eventDetailsInfo?.eventId || '';

    if(userEventDetails?.eventDetailsInfo?.celebrityInfo && userEventDetails?.eventDetailsInfo?.celebrityInfo.length > 0){
      let ownerName, coOwnerName, celebrityName;
      userEventDetails?.eventDetailsInfo?.celebrityInfo.forEach((info) => {
        if(info && info.iscoOwner && info.iscoOwner == "true"){
          coOwnerName = `${info.firstName ? info.firstName : ''}${info.lastName ? ` ${info.lastName}` : ''}${info.motherName ? ` ${info.motherName}` : ''}`
        }else if(info && info.iscoOwner && info.iscoOwner == "false" && info.primaryOwner && info.primaryOwner == "true" && info.hasPermission == true){
          ownerName = `${info.firstName ? info.firstName : ''}${info.lastName ? ` ${info.lastName}` : ''}${info.motherName ? ` ${info.motherName}` : ''}`
        }else if(info && info.iscoOwner && info.iscoOwner == "false" && info.primaryOwner && info.primaryOwner == "false" && info.isCelebrity == true){
          celebrityName = `${info.firstName ? info.firstName : ''}${info.lastName ? ` ${info.lastName}` : ''}${info.motherName ? ` ${info.motherName}` : ''}`
        }
      });

      this.setState({
        coOwnerName: coOwnerName,
        ownerName: ownerName,
        celebrityName: celebrityName,
      })
    }

    this._getUpdatedEventDetails();

    this.setState({
      eventType,
      eventDate,
      eventId
    });

  }

  _getUpdatedEventDetails = () => {
    this.props.getEventDetails(this.props.eventID,this.props.profileId).then((data) => {
      let ownerName, coOwnerName, celebrityName;
      if(data?.title === "error.unexpected"){
        this.props.showMessagePopUp(false,false,false,data?.detail || data?.title);
        return;
      }
      data?.eventDetailsInfo?.celebrityInfo.forEach((info) => {
        if(info && info.iscoOwner && info.iscoOwner == "true"){
          coOwnerName = `${info.firstName ? info.firstName : ''}${info.lastName ? ` ${info.lastName}` : ''}${info.motherName ? ` ${info.motherName}` : ''}`
        }else if(info && info.iscoOwner && info.iscoOwner == "false" && info.primaryOwner && info.primaryOwner == "true" && info.hasPermission == true){
          ownerName = `${info.firstName ? info.firstName : ''}${info.lastName ? ` ${info.lastName}` : ''}${info.motherName ? ` ${info.motherName}` : ''}`
        }else if(info && info.iscoOwner && info.iscoOwner == "false" && info.primaryOwner && info.primaryOwner == "false" && info.isCelebrity == true){
          celebrityName = `${info.firstName ? info.firstName : ''}${info.lastName ? ` ${info.lastName}` : ''}${info.motherName ? ` ${info.motherName}` : ''}`
        }
      });

      this.setState({
        coOwnerName: coOwnerName,
        ownerName: ownerName,
        celebrityName: celebrityName,
        showCreateEvent: true,
      })
    });
  }


  handleSaveEventNickName = (eventId, newEventName) => {
    saveEventName(eventId, newEventName, '').then((response) => {
      if (response.body.status.status === 'success') {
        this.props.handleSaveEventName(newEventName);
      }
    }).catch((e) => {
      console.log(e); // console required
    });
  }

  render() {
    const { userEventDetails } = this.props;

    const eventCategoryObj = {
      data : this.props.eventcategory
    }

    let formattedDate = "";
    let eventDateValue = userEventDetails?.eventDetailsInfo?.eventDate || this.state.eventDate; 
    if (eventDateValue && typeof eventDateValue === "string" && eventDateValue.includes("-")) {
        const [year, month, day] = eventDateValue.split("-");
        if (year && month && day) {
            formattedDate = `${day}/${month}/${year}`;
        }
    }

    if(
      userEventDetails?.eventDetailsInfo?.eventType &&
      userEventDetails?.status?.status === "success" &&
      this.state.showCreateEvent
    ){
    return (
      <React.Fragment>
        <ApplyCSS pageName={pageName} />
        <div id="gift-list-personalizacion">
          <div className="section-container personalSectionInfo">
            <div className="title-text">
              ¿Algo cambió en tu evento? Actualiza los detalles aquí
            </div>
            <div className="subtitle-text">
            {channel == "wap"
                ? "Solo algunos campos de los datos de tu evento pueden ser modificados por una persona asesora en tienda*"
                : "Solo algunos campos de los datos de tu evento pueden ser modificados por un vendedor en tienda*"}
            </div>
          </div>

          <div className="info-container personalSectionInfo">
            <div className={`info-row ${channel == 'wap' && "col-12"}`}>
              <div className={`info-label ${channel == 'wap' && "info-label-width col-6"}`}>Tipo de evento:</div>
              <div className={`info-value ${channel == 'wap' && "info-value-width col-6"}`}>{userEventDetails?.eventDetailsInfo?.eventType ? userEventDetails?.eventDetailsInfo?.eventType : this.state.eventType}</div>
            </div>

            <div className={`info-row ${channel == 'wap' && "col-12"}`}>
              <div className={`info-label ${channel == 'wap' && "info-label-width col-6"}`}>Fecha del evento:</div>
              <div className={`info-value ${channel == 'wap' && "info-value-width col-6"}`}>{formattedDate ? formattedDate : ""}</div>
            </div>

            <div className={`info-row ${channel == 'wap' && "col-12"}`}>
              <div className={`info-label ${channel == 'wap' && "info-label-width col-6"}`}>Número del evento:</div>
              <div className={`info-value ${channel == 'wap' && "info-value-width col-6"}`}>{userEventDetails?.eventDetailsInfo?.eventId ? userEventDetails?.eventDetailsInfo?.eventId : this.state.eventId}</div>
            </div>
          </div>

            <div
              style={{
                visibility: this.state.showCreateEvent ? "visible" : "hidden"
              }}
              id="create-event-container"
            >
              <CreateEvent
                isGiftListCreateEvent={true}
                eventDetailsInfo={userEventDetails.eventDetailsInfo}
                handleSaveEventNickName={this.handleSaveEventNickName}
                getEventDetails={this.props.getEventDetails}
                saveEventName={saveEventName}
                user={this.props.user}
                eventId={this.props.eventID}
                eventType={userEventDetails?.eventDetailsInfo?.eventType || this.state.eventType}
                ownerName={this.state.ownerName}
                coOwnerName={this.state.coOwnerName}
                celebrityName={this.state.celebrityName}
                profileId={this.props.profileId}
                handleValidateEventName={handleValidateEventName}
                eventcategory={eventCategoryObj}
                onActiveThemeColorUpdate={this.props.onActiveThemeColorUpdate}
                onBackClick={this.props.onBackClick ? this.props.onBackClick : ''}
                showMessagePopUp={this?.props?.showMessagePopUp || ''}
                selectedTheme={this.props.selectedTheme || {}}
                eventStatus={this.props.eventStatusInfo || ""}
              />
            </div>
        </div>
      </React.Fragment>
    );
    }

    return (
      <div>
        <ApplyCSS pageName={pageName} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  eventStatus: state.eventDetail.data?.eventList,
});

const matchDispatchToProps = dispatch => bindActionCreators({ handleSaveEventName }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(Personalization);
